const lightTheme = {
    '--elevate-color': '#ededed',
    '--background-color': '#ffffff',

    '--text-dark': '#5F5F5F',
    '--text-black': '#3C3C3C',
    '--text-light': '#666666',

    '--color-light': '#EEEEEE',
    '--color-black': '#161616',
    '--color-dark': '#707070',

    '--inversion-filter': 'invert(0)',
    '--picture-url': 'url(res/majda.png)'
}

const darkTheme = {
    '--elevate-color': '#020202',
    '--background-color': '#0B0B0B',

    //#F9F9F3
    '--text-dark': '#E0E0DB',
    '--text-black': '#F9F9F3',
    '--text-light': '#C7C7C2',

    '--color-light': '#1f1d1d',
    '--color-black': '#161616',
    '--color-dark': '#707070',

    '--inversion-filter': 'invert(0.8)',
    '--picture-url': 'url(res/majda-dark.png)'
}



function setTheme(theme: any) {
    for (const key in theme) {
        document.documentElement.style.setProperty(key, theme[key])
    }
}




let activeIndex = 0
const activeThemes = [lightTheme, darkTheme]

export function cycleThemes() {
    activeIndex += 1
    if (activeIndex >= activeThemes.length)
        activeIndex = 0

    localStorage.setItem('theme-index', activeIndex.toString())
    setTheme(activeThemes[activeIndex])
}

// set base theme
export function setBaseTheme() {
    const index = localStorage.getItem('theme-index')
    const idx: number = index == undefined ? 0 : parseInt(index);
    activeIndex = idx;

    setTheme(activeThemes[activeIndex])
}